import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import CartItem from '../components/cart/CartItem';
import CartInfoBoxItem from '../components/cart/CartInfoBoxItem';
import CartInfoDelivery from '../components/cart/CartInfoDelivery';
import CartInfoTotalSum from '../components/cart/CartInfoTotalSum';
import PageBanner from '../components/banner/PageBanner';
import { globalStatistic } from '../redux/actions/otherActions';
import { getCartFunction } from '../redux/actions/cartActions';
import { useTranslation } from 'react-i18next';

import { removeCartItemFunction, getCartDetailFunction } from '../redux/actions/cartActions';

const CartPage = () => {

    const dispatch = useDispatch();
    const { cartId } = useParams();
    const iconPath = process.env.PUBLIC_URL + '/images/';

    const getActiveCartFunction = useSelector((state) => state.getActiveCartFunction);
    const cartDetails = useSelector((state) => state.getActiveCartDetailsFunction);
    const activeCurrency = useSelector((state) => state.activeCurrency.item);
    const cartActiveDetail3 = useSelector((state) => state.getActiveCartFunction[0]);
    const getActiveCurrency = useSelector((state) => state.activeCurrency);

    const getCompanyAdditionalInfo = useSelector((state) => state.userInfo.userInfo.companyAdditionalInfo);
    const getCartListFunction = useSelector((state) => state.getCartListFunction.items);
    const [isBelgrade, setIsBelgrade] = useState(0);
    const [isVisibleInfoBoxDanger, setIsVisibleInfoBoxDanger] = useState(false);
    const [selectedDeliveryType, setSelectedDeliveryType] = useState('I');
    const getB2bSettings = useSelector((state) => state.getB2bSettings);
    const deliveryTypeSettings = getB2bSettings.items ? getB2bSettings.items.deliveryType : [];

    var selectedCart = getCartListFunction.filter((x) => x._id === cartId);
    const { t } = useTranslation('cartPage');

    useEffect(() => {
        dispatch(getCartDetailFunction(cartId));
    }, []);

    if (selectedCart.length > 0) {
        var isActiveCurrent = selectedCart[0].isActive;

        if (isActiveCurrent === 1) {
            var cartActiveDetail = cartActiveDetail3;
        } else {
            var cartActiveDetail = selectedCart[0];
        }
    } else {
        var cartActiveDetail = cartActiveDetail3;
    }

    const cartDeliveryCityFunction = (id) => {
        setIsBelgrade(id);
    }

    const removeCartItem = (anCartItemKey) => {
        dispatch(removeCartItemFunction(anCartItemKey, getActiveCartFunction));
    }

    var orderIsQualified = 1;
    if (activeCurrency.acShortName !== 'EUR') {
        if (isBelgrade == 1 && cartActiveDetail.anValueNoPdv < getB2bSettings.items.anValueForFreeDelivery1) {
            orderIsQualified = 0;
        } else if (isBelgrade == 0 && cartActiveDetail.anValueNoPdv < getB2bSettings.items.anValueForFreeDelivery2) {
            orderIsQualified = 0;
        }
    } else {
        if (isBelgrade == 1 && cartActiveDetail.anValueNoPdv < getB2bSettings.items.anValueForFreeDelivery1 / getCompanyAdditionalInfo.anFXRatePostponed) {
            orderIsQualified = 0;
        } else if (isBelgrade == 0 && cartActiveDetail.anValueNoPdv < getB2bSettings.items.anValueForFreeDelivery2 / getCompanyAdditionalInfo.anFXRatePostponed) {
            orderIsQualified = 0;
        }
    }
    const gatherStatisticEmptyCart = () => {
        dispatch(globalStatistic(0, 'EMPTY_CART'));
    }

    let text = cartActiveDetail.acVoucherNote;
    if (text) {
        var pieces = text.split(/[\s,]+/)
        pieces[pieces.length - 1] = parseFloat(pieces[pieces.length - 1]).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        var parsedVoucherAmmount = '';
        pieces.forEach((item) => {
            parsedVoucherAmmount += item + ' ';
        })
    }
    useEffect(() => {
        dispatch(getCartFunction(getActiveCurrency.item._id));
    }, [cartDetails]);


    // Memorisana vrednost sortirane liste stockItemsList
    // koristi useMemo da optimizuje performanse tako da se lista sortira
    // samo kada se promeni cartDetails
    const sortedStockItems = useMemo(() => {
        if (cartDetails && cartDetails.stockItemsList) {
            return [...cartDetails.stockItemsList].sort((a, b) =>
                // Ako je anStockKey === 0 za a, stavka a ide na početak (-1)
                // Ako je anStockKey === 0 za b, stavka b ide na početak (1)
                // U suprotnom, redosled ostaje nepromenjen (0)
                a.anStockKey === 0 ? -1 : b.anStockKey === 0 ? 1 : 0
            );
        }
        return [];  // Ako nema podataka, vraća se prazna lista
    }, [cartDetails]);
    // let test = sortedStockItems.forEach(stockItem => {
    //     stockItem.cartItemsList.forEach(item => {
    //         let pdv = item.anSumPriceWithPdv - item.anSumPriceNoPdv;
    //         item.anSumPriceWithPdv = Math.round(item.anSumPriceWithPdv * 100) / 100;
    //         item.anSumPriceNoPdv = Math.round(item.anSumPriceNoPdv * 100) / 100;
    //         item.anPriceNoPdv = Math.round(item.anPriceNoPdv * 100) / 100;
    //         pdv = Math.round(pdv * 100) / 100;
    //     })
    // });
    return (
        <div className="container-content container-main-cart-content">
            <div className="container-fluid">
                <div className="row">

                    <div className="main-cart-item-content">
                        <div className="main-cart-items-table">
                            <div className="cart-editing-mobile-button">
                                <Link to="/uredjivanje-korpi">
                                    <span className="settings-cart-button">{t('urediteKorpe')} <i className="fas fa-sliders-h"></i></span>
                                </Link>
                            </div>
                            <div className="title-cart-order">
                                {t('nazivKorpe')} (
                                <span>
                                    {cartActiveDetail && cartActiveDetail.acCartName === 'Default'
                                        ? t('podrazumevaniNazivKorpe')
                                        : cartActiveDetail.acCartName}
                                </span>
                                )
                            </div>
                            {cartActiveDetail &&
                                cartActiveDetail.cartItemsList &&
                                cartActiveDetail.cartItemsList.length > 0 ? (
                                <div className="main-cart-items-table-custom custom-style-table">
                                    {sortedStockItems &&
                                        sortedStockItems.map((stockItem, stockIndex) => {
                                            // Proverava da li je trenutni stockItem prvi (anStockKey === 0)
                                            const isFirstStockItem = stockItem.anStockKey === 0;
                                            return (
                                                <div
                                                    key={`${cartDetails._id}-${stockItem.anStockKey}`}
                                                    // Ako nije prvi item, dodeljujemo mu klasu "gray-background"
                                                    className={`stock-item-section ${!isFirstStockItem ? 'gray-background' : ''}`}
                                                >
                                                    <h4>{`Lager ${stockItem.acStockName}`}</h4>
                                                    <table className="table main-cart-table">
                                                        <thead>
                                                            <tr>
                                                                <th>{t('kolona1')}</th>
                                                                <th>{t('kolona2')}</th>
                                                                <th className="width-name-td">{t('kolona3')}</th>
                                                                <th className="width-120-td">{t('kolona4')}</th>
                                                                <th className="width-120-td">{t('kolona5')}</th>
                                                                <th>{t('kolona6')}</th>
                                                                <th className="text-center">{t('kolona7')}</th>
                                                                <th className="width-120-td">{t('kolona8')}</th>
                                                                <th className="width-150-td">{t('kolona9')}</th>
                                                                <th className="width-120-td">{t('kolona10')}</th>
                                                                {isActiveCurrent === 1 && (
                                                                    <>
                                                                        <th className="width-120-td">{t('kolona11')}</th>
                                                                        <th></th>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {stockItem.cartItemsList.map((cartItem) => (
                                                                <CartItem
                                                                    key={cartItem.anCartItemKey}
                                                                    item={cartItem}
                                                                    isActiveCurrent={isActiveCurrent}
                                                                    anStockKey={stockItem.anStockKey}
                                                                />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    {/* Ako stockIndex nije 0, prikazujemo informaciju o eksternom lageru */}
                                                    {stockIndex > 0 && (
                                                        <div className="external-stock-label">
                                                            <i className="fas fa-info cart-info-icon"></i> Vreme isporuke robe koja se porucuje sa eksternog lagera je 5 do 7 radnih dana.
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                </div>
                            ) : (
                                // <div className="alert alert-primary" role="alert">
                                //     Korpa je prazna
                                // </div>
                                <div className="empty-cart text-center">
                                    <img src={`${iconPath}korpa-siva.png`} alt="ikonica korpe" />
                                    <h5>{t('praznaKorpa')}</h5>
                                    <small>{t('nemaArtikalaUKorpi')}</small>
                                    <div className='empty-cart-button'>
                                        <Link to="/uredjivanje-korpi">
                                            <button className="btn btn-info">{t('povratak')}</button>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                        {isActiveCurrent == 1 && (
                            <>
                                {cartActiveDetail && cartActiveDetail.cartItemsList &&
                                    cartActiveDetail.cartItemsList.length > 0 && (
                                        <div className="row item-detail-cart-forms">
                                            <div className="col-sm-12">
                                                <div className="btn-remove-all-cart">
                                                    {/* <span className="button-remove-all-item"><i className="far fa-trash-alt"></i> Isprazni korpu</span> */}
                                                    <span className="btn-warning btn-sm btn" onClick={(e) => { removeCartItem(0); gatherStatisticEmptyCart() }}><i className="far fa-trash-alt"></i> {t('isprazniKorpu')}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="main-cart-info-block">
                                                    {selectedDeliveryType == 'K' ? (
                                                        <CartInfoBoxItem
                                                            isBelgrade={isBelgrade}
                                                            totalSum={cartActiveDetail.anValueNoPdv}
                                                            anFXRatePostponed={getCompanyAdditionalInfo.anFXRatePostponed}
                                                            activeCurrency={activeCurrency}
                                                            b2bSettings={getB2bSettings}
                                                            text=""
                                                            icon="fas fa-info"
                                                            type="info2"
                                                        />
                                                    ) : selectedDeliveryType == 'I' ? (
                                                        <>
                                                            {cartActiveDetail.anValueWithPdv != 0 && (
                                                                <>
                                                                    {orderIsQualified == 1 && <CartInfoBoxItem isBelgrade={isBelgrade} totalSum={cartActiveDetail.anValueNoPdv} anFXRatePostponed={getCompanyAdditionalInfo.anFXRatePostponed} activeCurrency={activeCurrency} b2bSettings={getB2bSettings} text="" icon="fas fa-info" type="success" />}
                                                                    {orderIsQualified == 0 && !isVisibleInfoBoxDanger && <CartInfoBoxItem isBelgrade={isBelgrade} totalSum={cartActiveDetail.anValueNoPdv} anFXRatePostponed={getCompanyAdditionalInfo.anFXRatePostponed} activeCurrency={activeCurrency} b2bSettings={getB2bSettings} text="" icon="fas fa-info" type="danger" />}
                                                                </>
                                                            )}
                                                        </>) : (
                                                        ""
                                                    )
                                                    }
                                                    <CartInfoBoxItem isBelgrade={isBelgrade} totalSum={cartActiveDetail.anValueNoPdv} anFXRatePostponed={getCompanyAdditionalInfo.anFXRatePostponed} activeCurrency={activeCurrency} isVisibleInfoBoxDanger={isVisibleInfoBoxDanger} b2bSettings={getB2bSettings} text="" icon="fas fa-info" type="info" />
                                                    {getB2bSettings?.items?.isDeliveryTransportPricesCaption == 1 && (
                                                        <div className="transport-notice">
                                                            <i className="fas fa-shipping-fast"></i>
                                                            <span>
                                                                Detaljni cenovnik transporta robe za krajnje korisnike pogledajte na
                                                                <a href="/stranica/1293" target="_blank" rel="noreferrer"> linku</a>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {cartActiveDetail && cartActiveDetail.acVoucherNote != '' &&
                                                        <div className="cart-info-box-voucher">
                                                            <img src='https://resource.ewe.rs/vouchers/vauceri.png' alt='robot'></img>
                                                            <span className='span-info-cart-box'>{parsedVoucherAmmount != undefined && parsedVoucherAmmount} {getB2bSettings?.items?.acLogOutUserCurrency || t('rsd')}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {/* <div className="col-sm-4">
                                                <div className="promo-code-content">
                                                    <div className="promo-code-content-input">
                                                        <div className="input-group-sm mb-2">
                                                            <label>Promotivni kod:</label>
                                                            <div className="small-info-promo-code">
                                                                <small>Vaše mišljenje nam je važno i uvek se trudimo da ga uvažimo kako bismo unapredili naše usluge. Odgovorite na nekoliko pitanja o vašem iskustvu na našem sajtu.</small>
                                                            </div>
                                                        </div>
                                                        <div className="input-group input-group-sm mb-2">
                                                            <input type="text" className="form-control input-sm" />
                                                            <button className="btn btn-sm btn-success promo-code-button-check">Primeni promo kod</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="col-sm-6">
                                                <CartInfoTotalSum />
                                            </div>
                                            <div className="col-sm-12">
                                                <CartInfoDelivery cartDeliveryCity={cartDeliveryCityFunction} cartActiveDetail={cartActiveDetail} activeCurrency={activeCurrency} setIsVisibleInfoBoxDanger={setIsVisibleInfoBoxDanger} setSelectedDeliveryType={setSelectedDeliveryType} cartDeliveryType={deliveryTypeSettings} sortedStockItems={sortedStockItems} />
                                            </div>

                                        </div>
                                    )
                                }
                            </>
                        )}


                    </div>
                </div>
                <div className="row">
                    <div className="main-cart-banner">
                        <PageBanner categoryType="" categoryId="" pageId="369" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartPage;